import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_GET_PROPERTY_FEATURES } from 'api/actionTypes';

export default async function getPropertyFeatures({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'propertyFeaturesById', listingId];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_GET_PROPERTY_FEATURES,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(redirection) {
      state.set(statePath, redirection);
    },
  });
}
